import { render, staticRenderFns } from "./PrenotazioneDialog.vue?vue&type=template&id=6ecfe530&"
import script from "./PrenotazioneDialog.vue?vue&type=script&lang=js&"
export * from "./PrenotazioneDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrenotazioneDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports